import React from 'react';
import { addLocaleData, IntlProvider } from 'react-intl';
import localeData_en from 'react-intl/locale-data/en';


import translations_en from './translations/en.json';


addLocaleData([
  ...localeData_en
]);

const { Provider, Consumer } = React.createContext();

// https://stackoverflow.com/a/51556636/1177636.
class IntlProviderWrapper extends React.Component {
  constructor(...args) {
    super(...args);

    const translations = {
      en: translations_en
    };

    let language =
      (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage || 'en';
    let locale = language.split(/[-_]/)[0]; // Language without region code.

    // If there is no translations found for this language,
    // check if the locale is found, otherwise use default 'en'.
    // For example, when 'en-US' doesn't have translations, but 'en' is found, use 'en' instead.
    if (!(language in translations)) {
      if (locale in translations) {
        language = locale;
      } else {
        language = 'en';
        locale = 'en';
      }
    }

    this.switchToEnglish = () => this.setState({ locale: 'en', translations: translations_en });

    this.state = {
      locale: locale,
      translations: translations[language],
      switchToEnglish: this.switchToEnglish,
    };
  }

  render() {
    const { children } = this.props;
    const { locale, translations } = this.state;
    return (
      <Provider value={this.state}>
        <IntlProvider key={locale} locale={locale} messages={translations} defaultLocale="en">
          {children}
        </IntlProvider>
      </Provider>
    );
  }
}

export { IntlProviderWrapper as IntlProvider, Consumer as IntlConsumer };
